import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollManager = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // no smooth, instant jump
  }, [pathname]);

  return null;
};

export default ScrollManager;
